import { LocalizedString } from "app/shared/model/localized-string.model";
import { Address, PhoneNumber } from "odq-toolbox";

export interface SpecialtyType {
  id: string
  code: string
  description: LocalizedString
  descriptionShort: LocalizedString
  isActive: boolean
}

export interface Municipality {
  id: string,
  name: string,
  code: string,
  postalCode: string,
  countryId: string,
  provinceId: string,
  electoralRegionId: string,
  administrativeRegionId: string,
  isActive: boolean,
}

export interface PublicMember {
  id: string;
  firstName: string;
  lastName: string;
  permitNumber: string;
}

export interface PublicMemberInfos extends PublicMember {
  effectiveExerciseStatus: ExerciseStatus
  effectiveInscriptionStatus: InscriptionStatus
  professionalDomicile: ProfessionalDomicile;
  specialtiTypeIds: string[];
  limitations: Limitation[];
  activeWorkAddresses: WorkAddress[];
  specialities: Speciality[];
  effectiveStatusDate: Date;
  firstInscriptionDate?: Date;
  permitType: LocalizedString;
  decisions: DecisionSanction[];
  isAnesthesiaHospital: boolean;
  isAnesthesiaPrivateClinic: boolean;
  isParticularMedicalCondition: boolean;
  isHomeVisit: boolean;
  isSleepApnea: boolean;
  isReducedMobility: boolean;
  isLiftPerson: boolean;
  effectiveInsuranceStatusCode: string;
}

export interface Limitation {
  periodType: string;
  startAt: Date;
  endAt: Date;
  origin: string;
  description: LocalizedString;
}
export interface Speciality {
  obtainedDate?: Date;
  description: LocalizedString;
}

export interface ProfessionalDomicile {
  id?: string;
  phone: PhoneNumber;
  fax: PhoneNumber;
  address: Address;
  wheelchairAccess: boolean;
  practiceType: string;
  isInCompany: boolean;
  effectiveOn: Date;
  practiceSince: Date;
  workAddressId?: string;
  clinicName?: string;
  typeOfPlace: string
}

export interface WorkAddress {
  address: Address;
  phone: PhoneNumber;
  fax: PhoneNumber;
  clinicName: string;
  isWheelchairAccessible: boolean;
}

export interface AdministrativeRegion {
  id: string
  code: string
  description: string,
  isActive: boolean
}

export interface PublicMemberSearchCriterias {
  cityName: string;
  specialtyTypeId: string;
  administrativeRegionCode: string;
}

export enum InscriptionStatus {
  Registered = 'Registered',
  NotRegistered = 'NotRegistered',
  PermanentNotRegistered = 'PermanentNotRegistered',
  NotAvailable = 'NotAvailable'
}

export enum ExerciseStatus {
  Active = 'Active',
  Inactive = 'Inactive',
  Terminated = 'Terminated',
  NotAvailable = 'NotAvailable'
}

export interface DecisionSanction {
  permitNumber: string;
  recordNumber: string;
  publicDecisionType: LocalizedString;
  decisionDate: Date;
  documents: DecisionDocument[]
}

export interface DecisionDocument {
  id?: string;
  decisionId?: string;
  documentId?: string;
  documentName: string;
  documentPath?: string;
  document?: File;
}

export interface InsuranceStatusCode {
  id: string
  code: string
  description: LocalizedString
  isActive: boolean
}